import { Buffer } from 'buffer'
import process from 'process'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'
import './styles.css'

if (!('Buffer' in globalThis)) {
  ;(globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer
}

if (!('process' in globalThis)) {
  ;(globalThis as typeof globalThis & { process: typeof process }).process = process
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
